@if (show && label) {
  <div class="card-label" [ngClass]="cssClass">
    @if (icon) {
      <mat-icon [svgIcon]="icon"></mat-icon>
    }
    {{label}}
  </div>
}